module.exports = __webpack_public_path__ + "static/glorious_4-ef3c70f2f827bd9339eba6df0ae3a949.jpg";